import React from 'react';

import HomepageComponent from '../HomepageComponent/HomepageComponent';

import instagramLogo from './assets/instagram-logo.svg';
import instagram01 from './assets/instagram-01.jpg';
import instagram02 from './assets/instagram-02.jpg';
import instagram03 from './assets/instagram-03.jpg';

import './styles/Instagram.scss';

export default (props) => {
  const images = props.images || [instagram01, instagram02, instagram03];
  
  return (
    <HomepageComponent
      className="Instagram"
      hoverClass="Instagram--hover"
      href={props.href}
      target="_blank"
    >
      <div className="Instagram-content">
        <img className="Instagram-logo" src={instagramLogo} alt="" />
        {
          images.map((image, i) => {
            return (
              <div
                key={i}
                className="Instagram-image"
                data-id={i}
                style={{backgroundImage: `url(${image})`}}
              />
            )
          })
        }
      </div>
    </HomepageComponent>
  );
}